import { t } from "@/i18n-js/instance";
import type { IconType } from "@circle-react-shared/Icon";
import { Dropdown } from "@circle-react-uikit/Dropdown";

interface HomeDropdownOptionsProps {
  displayWelcomeBanner: boolean;
  isCoverImageVisible: boolean;
  toggleCoverImageModal: () => void;
  toggleCustomizeModalWithSection: (text: string) => void;
}

interface Option {
  icon: IconType;
  label: string;
  onClick: () => void;
  value: string;
}

export const HomeDropdownOptions = ({
  toggleCustomizeModalWithSection,
  displayWelcomeBanner,
  toggleCoverImageModal,
  isCoverImageVisible,
}: HomeDropdownOptionsProps) => {
  const dropdownOptions: Option[] = [
    {
      label: isCoverImageVisible ? t("edit_cover") : t("add_cover"),
      value: t("add_cover"),
      onClick: toggleCoverImageModal,
      icon: "16-file-image",
    },
    {
      label: displayWelcomeBanner
        ? t("home_page.edit_welcome_banner")
        : t("home_page.add_welcome_banner"),
      value: t("home_page.add_welcome_banner"),
      onClick: () => toggleCustomizeModalWithSection(t("home_page.banners")),
      icon: "16-customize",
    },
    {
      label: t("home_page.options"),
      value: t("home_page.options"),
      onClick: () => toggleCustomizeModalWithSection(t("home_page.options")),
      icon: "16-info",
    },
  ];

  return <Dropdown.IconWithBadgeList options={dropdownOptions} />;
};
